import React, { Component } from "react";
import "./styles.css";
import Icon from "../../prefabs/icon/view";

class InputCounter extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.state = {
      showAddTooltip: false,
      showSubTooltip: false
    };

    this.onClickAddBtn = this.onClickAddBtn.bind(this);
    this.onClickSubBtn = this.onClickSubBtn.bind(this);
    this.onChangeTxt   = this.onChangeTxt.bind(this);
    this.handleAddMouseOver = this.handleAddMouseOver.bind(this);
    this.handleAddMouseOut = this.handleAddMouseOut.bind(this);
    this.handleSubMouseOver = this.handleSubMouseOver.bind(this);
    this.handleSubMouseOut = this.handleSubMouseOut.bind(this);
    this.tooltipTimeout = null;
    this.addTooltipTimeout = null;
    this.subTooltipTimeout = null;
  }



  // ===============================================================================================
  onClickSubBtn(e) {
    e.preventDefault();
    if (this.props.amount > this.props.min) {
      this.props.handleChange(this.props.amount - 1);
    } else {
      this.handleSubMouseOver(); // Show tooltip on click when at min
    }
  }



  // ===============================================================================================
  onClickAddBtn(e) {
    e.preventDefault();
    if (this.props.amount < this.props.max) {
      this.props.handleChange(this.props.amount + 1);
    } else {
      this.handleAddMouseOver(); // Show tooltip on click when at max
    }
  }



  // ===============================================================================================
  onChangeTxt(e) {
    e.preventDefault();

    // Get input and convert to a number
    let newVal = (e.target.value).replace(/[^0-9]/gi, '');  // Only allow number input
    newVal = parseInt(newVal, 10);

    // Parse input to make sure it's within the min and max bounds
    if (isNaN(newVal)) { newVal = 0; }
    if (newVal < this.props.min) { newVal = this.props.min; }
    if (newVal > this.props.max) { newVal = this.props.max; }

    // console.log(`Changing counter, ${e.target.value}`);
    this.props.handleChange( newVal );
  }



  // ===============================================================================================
  handleAddMouseOver() {
    if (this.props.amount >= this.props.max) {
      clearTimeout(this.addTooltipTimeout);
      this.setState({ showAddTooltip: true });
    }
  }

  handleAddMouseOut() {
    this.addTooltipTimeout = setTimeout(() => {
      this.setState({ showAddTooltip: false });
    }, 300);
  }



  // ===============================================================================================
  handleSubMouseOver() {
    if (this.props.amount <= this.props.min) {
      clearTimeout(this.subTooltipTimeout);
      this.setState({ showSubTooltip: true });
    }
  }

  handleSubMouseOut() {
    this.subTooltipTimeout = setTimeout(() => {
      this.setState({ showSubTooltip: false });
    }, 300);
  }



  // ===============================================================================================
  componentWillUnmount() {
    if (this.tooltipTimeout) {
      clearTimeout(this.tooltipTimeout);
    }
    if (this.addTooltipTimeout) {
      clearTimeout(this.addTooltipTimeout);
    }
    if (this.subTooltipTimeout) {
      clearTimeout(this.subTooltipTimeout);
    }
  }



  // ===============================================================================================
  render() {
    return (
      <div className={"input-counter" +
        ((this.props.disabled) ? " input-counter--disabled" : "")}>

        <div className="input-counter__left">
          {this.props.label}
        </div>

        <div className="input-counter__right">

          <input type="text" className="input-counter__txt"
            value={this.props.amount}
            tabIndex="-1"
            onChange={this.onChangeTxt}
            disabled={this.props.disabled}
          />

          <button className={"input-counter__btn input-counter__btn--left" +
            ((this.props.amount <= this.props.min) ? " input-counter__btn--inactive icon-inactive" : "")}
            tabIndex="-1"
            onClick={this.onClickSubBtn}>
            <div 
              className="input-counter__tooltip-container"
              onMouseOver={this.handleSubMouseOver}
              onMouseOut={this.handleSubMouseOut}
            >
              <Icon type="sub"/>
              {this.state.showSubTooltip && this.props.amount <= this.props.min && this.props.minTooltip && (
                <div className="input-counter__tooltip">
                  {this.props.minTooltip}
                </div>
              )}
            </div>
          </button>

          <button 
            className={"input-counter__btn input-counter__btn--right" +
              ((this.props.amount >= this.props.max) ? " input-counter__btn--inactive icon-inactive" : "")}
            tabIndex="-1"
            onClick={this.onClickAddBtn}
          >
            <div 
              className="input-counter__tooltip-container"
              onMouseOver={this.handleAddMouseOver}
              onMouseOut={this.handleAddMouseOut}
            >
              <Icon type="add"/>
              {this.state.showAddTooltip && this.props.amount >= this.props.max && this.props.maxTooltip && (
                <div className="input-counter__tooltip">
                  {this.props.maxTooltip}
                </div>
              )}
            </div>
          </button>

        </div>

      </div>
    );
  }

}



export default InputCounter
